import { render, staticRenderFns } from "./SportHeader.vue?vue&type=template&id=806786be&scoped=true"
import script from "./SportHeader.vue?vue&type=script&lang=js"
export * from "./SportHeader.vue?vue&type=script&lang=js"
import style0 from "./SportHeader.vue?vue&type=style&index=0&id=806786be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806786be",
  null
  
)

export default component.exports